const subscription = {
    limit_exceeded: '당신은 구독 플랜 한도에 도달하였습니다.',
    get_plan_failed: '임차인에 대한 구독 플랜을 가져올 수 없습니다.',
    tenant_suspended: '임차인이 정지되었습니다. 관리자에게 문의하십시오.',
};
export default Object.freeze(subscription);
